import { monitoring } from "@iyk/vf-observability/react"
import { Data } from "effect"

export type ActivityEvent = Data.TaggedEnum<{
  ExclusiveVideoPlayed: { exclusiveId: string }
  ExclusiveGalleryViewed: { exclusiveId: string }
  BuyLinkClicked: { merchSkuId: string }
  TrackPlayed: { trackId: string }
}>
export const ActivityEvent = Data.taggedEnum<ActivityEvent>()

export interface Activity {
  track(event: ActivityEvent): Promise<void>
}

export class ApiActivity implements Activity {
  track = async (event: ActivityEvent) => {
    await fetch("/activity/track", {
      method: "POST",
      body: JSON.stringify(event)
    }).catch((error) => monitoring.captureException(error))
  }
}
